import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { LogicContext } from '@/logic/main/types';

export const waitForHeader = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'WH_HEADER_TIMEOUT';
      }>
    ) => {
      let eventSent: boolean = false;
      const timeoutId = setTimeout(() => {
        console.log('Header initialized timeout');
        if (!eventSent) {
          callback({ type: 'WH_HEADER_TIMEOUT' });
        }
        eventSent = true;
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  );
